import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@material/material.module';

import { ThumbComponent } from './thumb.component';

@NgModule({
  declarations: [ThumbComponent],
  imports: [CommonModule, RouterModule, MaterialModule],
  exports: [ThumbComponent],
})
export class ThumbModule {}
